/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import 'firebase/auth';
import firebase from './firebase';

const auth = firebase.auth();

export { auth as default };
